export const menuData: any = [
  {
    name: '首页',
    path: '/',
    i18nKey: 'menu.home'
  },
  {
    name: '关于比优',
    path: '/about',
    i18nKey: 'menu.about',
    children: [
      {
        name: '集团介绍',
        path: '/about',
        i18nKey: 'menu.introduction'
      },
      {
        name: '公司高管',
        path: '/about/executives',
        i18nKey: 'menu.executives'
      },
      // {
      //   name: '主席致辞',
      //   path: '/about/president_speech',
      //   i18nKey: 'menu.president_speech'
      // },
      {
        name: '发展历程',
        path: '/about/group_events',
        i18nKey: 'menu.group_events'
      },
      // {
      //   name: '价值观念',
      //   path: '/about/core_value',
      //   i18nKey: 'menu.core_value'
      // },
      {
        name: '集团荣誉',
        path: '/about/honors',
        i18nKey: 'menu.honors'
      },
      {
        name: '组织架构',
        path: '/about/group_structure',
        i18nKey: 'menu.group_structure'
      },
      {
        name: '技术实力',
        path: '/business/technical',
        i18nKey: 'menu.technical'
      },
      {
        name: '集团视频',
        path: '/about/video',
        i18nKey: 'menu.company_video'
      },
    ]
  },
  {
    name: '主营业务',
    path: '/business/mining',
    i18nKey: 'menu.main_business',
    children: [
      {
        name: '矿产开发',
        path: '/business/mining',
        i18nKey: 'menu.mining'
      },
      {
        name: '矿山建设',
        path: '/business/mine-construction',
        i18nKey: 'menu.mine-construction'
      },
      {
        name: '民爆生产',
        path: '/business/explosives',
        i18nKey: 'menu.explosives'
      },
      // {
      //   name: '海外业务',
      //   path: '/business/overseas',
      //   i18nKey: 'menu.overseas'
      // },
    ]
  },
  {
    name: '新闻中心',
    path: '/news',
    i18nKey: 'menu.news',
    children: [
      {
        name: '全部新闻',
        path: '/news',
        i18nKey: 'menu.all_news'
      },
      {
        name: '集团新闻',
        path: '/news?category=1',
        i18nKey: 'menu.group_news'
      },
      {
        name: '媒体动态',
        path: '/news?category=2',
        i18nKey: 'menu.media'
      },
    ]
  },
  {
    name: '投资者关系',
    path: '/notice',
    i18nKey: 'menu.investors',
    children: [
      {
        name: '公告与通函',
        path: '/notice',
        i18nKey: 'menu.notice'
      },
      {
        name: 'ESG管理',
        path: '/notice/esg',
        i18nKey: 'menu.esg_management'
      }
    ]
  },
  {
    name: '联系我们',
    path: '/contact',
    i18nKey: 'menu.contact'
  },
  {
    name: '招聘信息',
    path: '/recruitment',
    i18nKey: 'menu.join_us',
    languages: ['cn', 'tc'],
    children: [
      {
        name: '自荐投递',
        path: '/join_us',
        languages: ['cn', 'tc'],
        i18nKey: 'menu.recruitment_intro'
      },
      {
        name: '招聘列表',
        path: '/recruitment',
        languages: ['cn', 'tc'],
        i18nKey: 'menu.recruitment_list'
      },
    ]
  }
];
